import { faAngleDown, faAngleUp } from '@fortawesome/pro-regular-svg-icons';
import { HoverIconButton } from 'components/button/HoverIconButton';
import * as React from 'react';

const getIcon = (expandType: string, expanded: boolean) => {
    if (expandType === 'upward') {
        return expanded ? faAngleDown : faAngleUp;
    }
    return expanded ? faAngleUp : faAngleDown;
};

type NavigationItemExpandButtonProps = Readonly<{
    expandType: 'downward' | 'upward';
    expanded: boolean;
    className?: string;
    onClick?: (
        event: React.MouseEvent<Element, MouseEvent> | React.KeyboardEvent<Element>,
    ) => void;
}>;

export function NavigationItemExpandButton({
    expandType,
    expanded,
    className,
    onClick,
}: NavigationItemExpandButtonProps) {
    return (
        <HoverIconButton
            size="1.8rem"
            className={className}
            aria-label={expanded ? 'Collapse' : 'Expand'}
            title={expanded ? 'Collapse' : 'Expand'}
            icon={getIcon(expandType, expanded)}
            hoverIcon={getIcon(expandType, expanded)}
            color="currentColor"
            onClick={onClick}
        />
    );
}
